var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnectIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 85,
    viewBox: "0 0 84 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0705566,
    width: 84,
    height: 84,
    rx: 10,
    fill: "url(#paint0_linear_10_6776)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_6776)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.8966 37.1432L23.0625 45.9753C18.9792 50.058 18.9792 56.7007 23.0625 60.7834L23.2831 61.004C25.2613 62.9812 27.8911 64.0705 30.6888 64.0705C33.4865 64.0705 36.1166 62.9812 38.0945 61.004L46.5946 52.5059C45.9719 52.5959 45.3388 52.6422 44.6983 52.6422C42.9362 52.6422 41.2279 52.2951 39.6508 51.6338L34.2968 56.9864C33.3331 57.9498 32.0517 58.4806 30.6888 58.4806C29.3262 58.4806 28.0449 57.9502 27.0811 56.9867C26.1187 56.0246 25.5886 54.7436 25.5886 53.3794C25.5886 52.0154 26.1187 50.7341 27.0808 49.772L35.6943 41.1608C36.6581 40.197 37.9395 39.6666 39.3024 39.6666C40.6203 39.6666 41.861 40.1638 42.813 41.0678C42.8476 41.096 42.8809 41.1259 42.9131 41.1581C43.3901 41.6348 44.0239 41.8973 44.6983 41.8973C45.3724 41.8973 46.0065 41.6348 46.4832 41.1581L48.4117 39.2302C47.9918 38.5568 47.496 37.9308 46.9286 37.3638L46.7084 37.1436C44.7302 35.1656 42.1 34.0767 39.3027 34.0767C36.505 34.0767 33.8749 35.1656 31.8966 37.1432Z",
    fill: "#00B2E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9377 38.1658C62.9126 36.1919 63.9999 33.5624 63.9999 30.7617C63.9999 27.9614 62.9123 25.3319 60.9377 23.3577L60.7175 23.1375C58.7393 21.1599 56.1091 20.0706 53.3115 20.0706C50.5141 20.0706 47.884 21.1599 45.9057 23.1375L37.4056 31.6352C38.0284 31.5452 38.6618 31.4989 39.3023 31.4989C41.064 31.4989 42.7724 31.8463 44.3495 32.5073L49.7034 27.1547C50.6672 26.1913 51.9485 25.6605 53.3115 25.6605C54.6744 25.6605 55.9557 26.1909 56.9195 27.1547C57.8819 28.1168 58.4117 29.3978 58.4117 30.7617C58.4117 32.126 57.8819 33.407 56.9195 34.3687L48.3059 42.9803C47.3422 43.9441 46.0608 44.4745 44.6979 44.4745C43.3803 44.4745 42.1396 43.9773 41.1876 43.0733C41.153 43.0451 41.1194 43.0152 41.0872 42.983C40.6105 42.5063 39.9764 42.2438 39.3023 42.2438C38.6279 42.2438 37.9941 42.5063 37.5174 42.983L35.5889 44.9112C36.0085 45.5843 36.5043 46.21 37.0716 46.7773L37.2922 46.9979C39.2704 48.9754 41.9002 50.0644 44.6979 50.0644C47.4956 50.0644 50.1257 48.9754 52.1036 46.9979L60.9377 38.1658Z",
    fill: "#00B2E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10_6776",
    x1: 42,
    y1: 0.0705566,
    x2: 42,
    y2: 84.0706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FD0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_6776"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white",
    transform: "translate(20 20.0706)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectIcon);
export default __webpack_public_path__ + "static/media/connectIcon.38e7b7ac3dbb8cc7c1c9893c5b3f89c8.svg";
export { ForwardRef as ReactComponent };